import { z } from "zod";
import { CompositionConfigLight } from "../../../types";
import { SLIDESHOW_START_FRAME } from "./constants";
import { SpiralSlideshowV1Props } from "./types";

const SpiralSlideshowV1Config: CompositionConfigLight<SpiralSlideshowV1Props> = {
	name: "SpiralSlideshowV1",
	assertValidProps: (unknownProps) => {
		const props = z
			.object({
				imageUrls: z.array(z.string()).min(1).max(30),
				previewUrls: z.array(z.string()).optional(),
				primaryText: z.string(),
				secondaryText: z.string().optional(),
			})
			.parse(unknownProps) satisfies SpiralSlideshowV1Props;
		if (props.previewUrls && props.previewUrls.length !== props.imageUrls.length) {
			throw new Error("Image array length mismatch");
		}
		return props;
	},
	videoConfig: {
		numFrames: (props) => SLIDESHOW_START_FRAME + 12 * props.imageUrls.length,
		width: 1080,
		height: 1920,
	},
};

export default SpiralSlideshowV1Config;
